










import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { Variant, VariantType } from '~/models/app/variant'

export default defineComponent({
  props: {
    variant: {
      type: String as PropType<VariantType>,
      default: null
    },
    wrapText: {
      type: Boolean,
      default: false
    },
    cols: { type: Number }
  },
  setup(props) {
    const cellClasses = computed(() => {
      const classes = []

      if (props.variant === Variant.PRIMARY) {
        classes.push('!tw-bg-primary-200')
      } else if (props.variant === Variant.DANGER) {
        classes.push('!tw-bg-red-200')
      } else if (props.variant === Variant.WARNING) {
        classes.push('!tw-bg-yellow-200')
      } else {
        classes.push('!tw-bg-white')
      }

      if (!props.wrapText) {
        classes.push('tw-whitespace-nowrap')
      }

      return classes
    })

    return { cellClasses }
  }
})
